/* A grid of cards.

   A card that names a route is the way there — the hub is nothing but cards —
   so the whole card is the link, not a word inside it. A card whose href is not
   a route of this portal is rendered as a card and nothing more: a link that
   lands nowhere is worse than none, and it is what caught the last of the old
   portal's `#/` addresses when the content was converted.

   OWNED BY ITEM 3 OF docs/plan/00-prestavba-2026-08.md. */

import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { Head, T } from "./shared";
import type { CardsBlock } from "../lib/types";

export function Cards({ b }: { b: CardsBlock }) {
  const { href } = useI18n();
  return (
    <>
      <Head b={b} />
      <div className={"grid " + (b.cols === 2 ? "g2" : "g3")}>
        {b.items.map((it, i) => {
          const body = (
            <>
              {it.n ? <div className="n"><T value={it.n} /></div> : null}
              <h3><T value={it.title} /></h3>
              {it.d ? <p className="d"><T value={it.d} /></p> : null}
              {it.foot ? <div className="foot"><T value={it.foot} /></div> : null}
            </>
          );
          return it.href?.startsWith("/")
            ? <Link key={i} className="card" to={href(it.href)}>{body}</Link>
            : <div key={i} className="card">{body}</div>;
        })}
      </div>
    </>
  );
}
